import EmojiPicker from "emoji-picker-react";
import { useRef } from "react";
import { useEffect } from "react";

const ChatEmojisPicker = ({ setNewMessageText, setIsShowEmojis }) => {
    const emojiRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiRef.current && !emojiRef.current.contains(event.target)) {
                setIsShowEmojis(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            className="emojis-container"
            tabIndex={0}
            ref={emojiRef}
        >
            <EmojiPicker
                skinTonePickerLocation="PREVIEW"
                height={360}
                onEmojiClick={(e) => {
                    setNewMessageText(prev => prev + e.emoji);
                }}
            />
        </div>

    );
}

export default ChatEmojisPicker;